<template>
    <div class="main-background">
            <div class="filter-page-container">
          <div class="filter-page-back-button" @click="returnToLastPage">
            <chevron-left-icon class="back-button-icon"/>
            <p class="back-button-text">Filters</p>
          </div>
          <div class="filter-category-container">
            <p class="filter-category-title">Categories</p>
            <div class="filter-category-list">
                <div class="filter-category-item" 
                @click="setCheckCategory(category)"
                :style="checkedCategory.find(el => el === category.id) ?
                    { background: '#343745', color: '#FFF' } : {}" 
                v-for="category of allCategories" 
                :key="category.id">
                {{ category.name }}
                </div>
            </div>
          </div>
          <div class="filter-category-container">
            <p class="filter-category-title">Price</p>
            <div class="filter-price-inputs-container">
                <div class="filter-inputs-blocks">
                    <p class="filter-input-text">From:</p>
                    <input class="filter-inputs" placeholder="0" type="text" v-model="inputMinimum">
                </div>
                <div class="filter-inputs-blocks">
                    <p class="filter-input-text">To:</p>
                    <input class="filter-inputs" placeholder="0" type="text" v-model="inputMax">
                </div>
            </div>
                <range-input
                :priceDown="priceDown"
                :priceUp="Number(this.getMaxPrice)"
                :filterValue="[
                    getFilterParametrs.price_from || 0,
                    getFilterParametrs.price_to || Number(this.getMaxPrice)
                ]"
                @setChangePrice="setChangePrice"
                />
          </div>
          <!-- <p class="bottom-filter-all-product">{{ `Знайдено товарів:${0}` }}</p> -->
          <div class="bottom-filter-button-container">
                <button 
                class="filtration-button" 
                @click="setFilterProducts"
                >
                Filter
            </button>
          </div>
        </div>
    </div>
</template>

<script>

import { ChevronLeftIcon } from 'vue-feather-icons'
import RangeInput from '../../../components/RangeInput.vue'
import { mapMutations } from "vuex"

export default {
    name: "filter-page",
    components: {
        ChevronLeftIcon,
        RangeInput
    },
    props: {
        categories: {
            type: Array,
            required: true
        },
        isShowPage: {
            type: String,
            required: true
        }
    },
    data() {
        return {
          carouselItems: [],
          checkedCategory: [],
          priceDown: 0,
          priceUp: 0,
          inputMax: 0,
          inputMinimum: 0
        }
    },
    mounted() {
        this.carouselItems = this.categories
        this.$store.dispatch('getAllProducts')
        if (Object.keys(this.getFilterParametrs).length) {
            this.checkedCategory = this.getFilterParametrs.category_ids || []
        } 
    },
      computed: {
        allHeaderCategories() {
            return this.$store.getters.allHeaderCategories;
        },
         allCategories() {
            return this.$store.getters.allCategories
        },
        perPageName() {
            return this.$store.getters.perPageName
        },
        getMaxPrice() {
            return this.$store.getters.getMaxPrice
        },
        getFilterParametrs() {
            return this.$store.getters.getFilterParametrs
        }
    },
    methods: {
        ...mapMutations(['setFilterParametrs','deleteFilterCategoryParametr', 'deleteFilterParametr', 'setFilterPriceParametrs', 'addPerPage']),
        setFilterProducts() {
            let data = {
                category_ids: this.checkedCategory.length ? this.checkedCategory : null,
                price_from: this.inputMinimum,
                price_to: this.inputMax
            }
            this.$store.dispatch('searchedProducts', data)
            this.setFilterParametrs(data)
            this.$emit('setIsChangePage', 'product')
        },
        setChangePriceCounter(price, value) {
            let data
            if (value === 'max') {
                data = {
                    category_ids: this.checkedCategory.length ? this.checkedCategory : null,
                    price_from: this.inputMinimum,
                    price_to: Number(price)
                }
            } else {
                 data = {
                    category_ids: this.checkedCategory.length ? this.checkedCategory : null,
                    price_from: Number(price),
                    price_to: this.inputMax
                }
            }
            this.setFilterParametrs(data)
        },
        returnToLastPage() {
            if (this.perPageName === 'product') {
                this.$emit('setIsChangePage', 'product')
            } else {
                this.$emit('setIsChangePage', 'home')
            }
            this.addPerPage('')
            this.deleteFilterParametr()
        },
        setCheckCategory(value) {
            console.log({value})
            if (this.checkedCategory?.find(el => el === value.id)) {
              this.checkedCategory = this.checkedCategory.filter(el => el !== value.id)
            } else {
               this.checkedCategory = [...this.checkedCategory, value.id] 
            }
            if (!this.checkedCategory.length) {
                this.deleteFilterCategoryParametr()
            }
        },
        setChangePrice(value) {
            this.inputMinimum = value[0]
            this.inputMax = value[1]
        }
    },
    watch: {
       inputMinimum(newValue, oldValue) {
        let val = oldValue
        val
        this.setChangePriceCounter(newValue, 'min')
       },
       inputMax(newValue, oldValue) {
        let val = oldValue
        val
        this.setChangePriceCounter(newValue, 'max')
        },  
    }
}
</script>

<style scoped>
.main-background {
    background: #fff;
    padding-left: 16px;
    padding-right: 16px;
}
.filter-page-back-button {
    position: relative;
    border-bottom: 1px solid #F0F0F0;
    padding: 18px;
    cursor: pointer;
}
.back-button-icon {
    position: absolute;
}
.back-button-text {
    text-align: center;
}
.filter-category-container {
 padding: 0 12px;
 margin-top: 11px;
}
.filter-category-title {
    color: #333;
    font-family: Inter;
    font-size: 18px;
    font-weight: 600;
    line-height: 24px;
}
.filter-category-list {
    display: flex;
    flex-wrap: wrap;
    gap: 12px;
    margin-top: 16px;
}
.filter-category-item {
    border-radius: 16px;
    border: 1px solid #B5B9BF; 
    color: #333;
    text-align: center;
    font-family: Inter;
    font-size: 10px;
    font-weight: 600;
    line-height: 18px; 
    background: #fff;
    padding: 7px 10px;
    cursor: pointer;
}
.filter-price-inputs-container {
    display: flex;
    margin-top: 8px;
    gap: 26px;
}

.filter-inputs-blocks {
    display: flex;
    gap: 4px;
}
.filter-input-text {
   color: #000;
    font-family: Inter;
    font-size: 10px;
    font-weight: 500;
    height: 12px;
    margin: auto 0;
}
.filter-inputs {
  border-radius: 4px;
  border: 1px solid #D2D6DB;
  background: #FFF;  
  padding: 6px 13px;
  color: #000;
font-family: Inter;
font-size: 10px;
font-weight: 500;
line-height: 20px;
width: 70px;
outline-color: #343745;
}

.bottom-filter-button-container {
  background: #FFF;
  box-shadow: 0px -4px 4px 0px rgba(0, 0, 0, 0.04);
  padding: 16px
}

.filtration-button {
    padding: 12px;
    width: 100%;
    border-radius: 8px;
    background: #343745;  
    color: #FFF;
    text-align: center;
    font-family: Inter;
    font-size: 18px;
    font-weight: 600;
    line-height: 24px;
    border: none;
    cursor: pointer;
}
.filter-page-container {
    display: flex;
    flex-direction: column;
    height: 90vh;
}

.bottom-filter-all-product {
 color: #707070;
font-family: Inter;
font-size: 10px;
font-weight: 500;
line-height: 20px;
padding-left: 16px;
margin-top: auto;
}
</style>